import React from 'react'
import landimage from "../../assets/images/landimg.png"
import { Link, useNavigate } from 'react-router-dom'
import GetLandDetailsByProjectId from '../../APIs/Land/GetLandDetailsByProjectId'
import DeleteProject from '../../APIs/Project/DeleteProject'

export default function ProjectCard(props) {
    let navigate = useNavigate()
    let handleShow = async () => {
        try {
            let resp = await GetLandDetailsByProjectId(props.projectData.id);
            if (resp.status === 1) {
                console.log("All Land Data:", resp.responseValue);

                // Corrected the structure of sessionStorage object
                window.sessionStorage.setItem("ProjectData", JSON.stringify({
                    allLandData: resp.responseValue,
                    projectId: props.projectData.id,
                    projectData: {
                        projectName: props.projectData.name,
                        projectNo: props.projectData.projectNo,
                        projectId: props.projectData.id,
                        projectPrice: props.projectData.projectPrice,
                        projectArea: props.projectData.projectArea,
                        unitName: props.projectData.SquareFoot,
                        landmark: props.projectData.landmark,
                        projectImageUrl: props.projectData.projectImageUrl,
                        isApproved: props.projectData.isAuthorized

                    }
                }));

                navigate("/projectdashboard/");
            } else {
                window.sessionStorage.setItem("ProjectData", JSON.stringify({
                    allLandData: [],
                    projectId: props.projectData.id,
                    projectData: {
                        projectName: props.projectData.name,
                        projectNo: props.projectData.projectNo,
                        projectId: props.projectData.id,
                        projectPrice: props.projectData.projectPrice,
                        projectArea: props.projectData.projectArea,
                        unitName: props.projectData.SquareFoot,
                        landmark: props.projectData.landmark,
                        projectImageUrl: props.projectData.projectImageUrl,
                        isApproved: props.projectData.isAuthorized
                    }
                }));
                // Handle failure case (if needed)
                console.error("Failed to fetch land details");
            }
        } catch (error) {
            console.error("Error occurred:", error);
        }
    };


    let handleDelete = async (id) => {
        let resp = await DeleteProject(id)
        if (resp.status === 1) {
            props.getData()
        }
    }
    return (
        <>
            <div className="card " style={{ "width": "100%", border: "none" }}>
                {/* <img src={landimage} className="card-img-top p-3" alt="..." /> */}
                <img
                    src={
                        props.projectData.projectImageUrl
                            ? `${window.RealestateService}${props.projectData.projectImageUrl}`
                            : landimage
                    }
                    className="card-img-top p-3 project-img"
                    alt="Project"
                />
                <div className="card-body pt-0">
                    <div className='d-flex flex-row justify-content-between'>
                        <div className='d-flex flex-column pb-2'>
                            <h6 className="card-title">{props.projectData.name}    <span className={`ms-2 badge ${props.projectData.isAuthorized ? 'bg-success' : 'bg-danger'}`}>
                                {props.projectData.isAuthorized ? 'Approved' : 'Unapproved'}
                            </span>
                            <span style={{fontSize:'12px',marginLeft:'5px'}}>{props.projectData.approvedBy? `(${props.projectData.approvedBy})`:''}</span>
                            </h6>
                            <span className='card-refrence'>
                                #{props.projectData.projectNo}
                            </span>
                        </div>

                        <div class="dropdown dropend">

                            <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                            <ul className="dropdown-menu mr-3">
                                <li><span className="dropdown-item" onClick={() => { handleDelete(props.projectData.id) }}>Delete</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="d-flex flex-row justify-content-between card-text pb-3 pt-1">
                        <div className='d-flex flex-row gap-2'>
                            <i class="fa-solid fa-indian-rupee-sign rupee-icon"></i>
                            <span className='price text-secondary'>{props.projectData.totalLandPrice}</span>
                        </div>
                        <div className='d-flex flex-row gap-2'>
                            <i class="fa-solid fa-location-dot rupee-icon"></i>
                            <span className='price text-secondary'>{props.projectData.landmark}</span>
                        </div>
                    </div>
                    <span className="btn btn-primary" onClick={handleShow}>View Details</span>
                </div>
            </div>
        </>
    )
}
